import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { VigenciaTributoShow } from '../../components'
import * as vigenciaTributoActionCreators from '../../redux/modules/vigenciaTributo'
import * as flashMessageActionCreators from '../../redux/modules/flashMessage'

class VigenciaTributoShowContainer extends Component {

  static propTypes = {
    concessionaria: PropTypes.object.isRequired,

    id: PropTypes.string,
    history: PropTypes.object,
    fetchVigenciaTributo: PropTypes.func,
    destroyVigenciaTributo: PropTypes.func,

    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
  }

  state = {
    vigenciaTributo: null
  }

  async componentDidMount () {
    if (this.props.id) {
      const vigenciaTributo = await this.props.fetchVigenciaTributo(this.props.id)
      this.setState({ vigenciaTributo })
    }
  }

  handleEditResource = (concessionariaId, id) => {
    this.props.history.push(`/concessionarias/${concessionariaId}/tributos/${id}/edit`)
  }

  handleDeleteResource = async (concessionariaId, id) => {
    if (await this.props.destroyVigenciaTributo(id)) {
      this.props.showSuccessfulFlashMessage('', 'destroy')
      this.props.history.push(`/concessionarias/${concessionariaId}/tributos`)
    } else {
      this.props.showErrorFlashMessage('', 'destroy', this.props.error)
    }
  }

  render () {
    return (
      <VigenciaTributoShow
        concessionaria={this.props.concessionaria}
        onEditResource={() => this.handleEditResource(this.props.concessionaria.id, this.state.vigenciaTributo.id)}
        onDeleteResource={() => this.handleDeleteResource(this.props.concessionaria.id, this.state.vigenciaTributo.id)}
        vigenciaTributo={this.state.vigenciaTributo} />
    )
  }
}

function mapStateToProps ({vigenciaTributo}, {match}) {
  const { id } = match.params
  if (id) {
    return {
      id,
      vigenciaTributo: vigenciaTributo.get('id'),
    }
  }
  return {}
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...vigenciaTributoActionCreators,
    ...flashMessageActionCreators
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VigenciaTributoShowContainer))
